
( ( $ ) => {

	if ( $( ".product-checkboxes" ).length > 0 )
	{
        
          function updateView() {
              var totalCheckboxes = $(".product-checkboxes tr").length
              var totalChecked = $("input.checkbox:checked").length
              
    // count of all checked inputs with class .checkbox
    /*if ($("input.checkbox:checked").length > 10) { 
      $('.form-box').show();
      $('.message-2').show();
      $('.message-1').hide();
    }*/ 
              
              if (totalChecked == totalCheckboxes) { 
      $('.form-box').show();
      $('.message-2').show();
      $('.message-1').hide();
    }
              else {
      $('.form-box').hide();
      $('.message-2').hide();
      $('.message-1').show();
    }
  }

  // match all inputs with class .checkbox
  $("input.checkbox").change(function(event) {
    updateView();
  });

  // initialize
  updateView();
  $('.form-box').hide();
  $('.message-2').hide();
		
	}
    


} )( jQuery );